import React from 'react';
import yaml from 'js-yaml';
// renderers is imported separately so Markdoc isn't sent to the client
import Markdoc, {renderers} from '@markdoc/markdoc'

import {getSchema, defaultObject} from '/vercel/path0/node_modules/@markdoc/next.js/src/runtime.js';
/**
 * Schema is imported like this so end-user's code is compiled using build-in babel/webpack configs.
 * This enables typescript/ESnext support
 */
const config = {};
import * as tags from '/vercel/path0/markdoc/tags/index.ts'
import * as nodes from '/vercel/path0/markdoc/nodes/index.ts'
const functions = {};
const schema = {
tags: defaultObject(tags),
nodes: defaultObject(nodes),
functions: defaultObject(functions),
...defaultObject(config),
};

const tokenizer = new Markdoc.Tokenizer();

/**
 * Source will never change at runtime, so parse happens at the file root
 */
const source = "---\ntitle: Ankr to Boost Covalent’s Network For Optimal Multi-Chain Experience, Staking Rewards & More!\ndate: 2021-04-01T04:25:15-04:00\ncategories: [\"ecosystem\"]\ndescription: Covalent Announces Partnership with Ankr\nauthor: niall\nsubbrand_image: https://www.covalenthq.com/static/images/blog/202103/ankr.jpg\ntype: legacy\n---\n\n**VANCOUVER, April 1st, 2021** - We are happy to announce that Ankr has entered into a strategic collaboration with Covalent, a Web3 data analytics company that provides a unified API for full transparency and visibility of assets across all blockchain networks\n\n\n\nCovalent is currently the only solution that allows to fully index entire blockchains, extracting terabytes of data — and its API requires no coding on the users’ side. Ankr, on the other hand, provides some of the best-in-class infrastructure that can help Covalent to strengthen its distributed network.\n\nWith multi-chain flexibility and ‘Lego-like’ building blocks approach enabled by its API solution, Covalent allows building cryptocurrency wallets for all purposes, including multi-chain wallets. Ankr’s infrastructure, in turn, allows to scale such products and power them for public use.\n\n**Seed investment and joint use-cases**\n\nAfter Ankr’s investment in [\"Covalents funding round\"](https://www.covalenthq.com/blog/covalent-strategic-funding-mar-2021/) which included Hashed, Coinbase, and Binance as well as many other industry heavyweights, it only makes sense to further deepen our relationship with this broad collaboration, bringing new use cases and nearing Web3 adoption as a result.\n\nSo, how will Ankr and Covalent strengthen each others ecosystems?\n\n## Infrastructure for Covalent Users\n\nFirst of all, Ankr will provide infrastructure services to Covalent, specifically helping to bootstrap its distributed network. Additionally, Ankr will leverage its experience to provide easy and affordable nodes to the Covalent community in order to further decentralize Covalent’s node infrastructure and enable developers to analyze Covalent on-chain data.\n\n## Validator for Covalent Network\n\nAnkr will run its own Covalent validator node for its investors to safely stake Covalent’s native token and earn staking rewards while contributing to strengthening the Covalent network.\n\nAnd there will be more interesting collaborations for Ankr and Covalent community members and developers, which will be announced in the very near future, so please stay tuned!\n\n\n## About Ankr\n\nAnkr is a Web3 infrastructure and cross-chain staking DeFi platform that aims to make it easy and affordable for anyone to participate in blockchain ecosystems by building dapps, hosting nodes or staking.\n\nAnkr’s product line includes:\n\n- One click solutions for staking nodes with rewards earning possibilities at [https://app.ankr.com/](https://app.ankr.com/).\n- Easily build Web3 products with instant API access to major blockchain, DeFi and Layer2 protocols.\n- Turnkey infrastructure solutions for blockchain native enterprises such as cryptocurrency exchanges, staking platforms, data analytics providers and more.\n- Decentralized cross-chain staking with instant liquidity\n\n[Website](https://www.ankr.com/) | [Twitter](https://twitter.com/ankr) | [Telegram Announcements](https://t.me/anrknetworkann) | [Telegram English Chat| LinkedIn](https://t.me/ankrnetwork) | [Instagram](https://www.instagram.com/ankr_cloud/) | [Ankr Staking](https://eth2.ankr.com/) | [Discord](https://discord.gg/e4n8mAejGb)\n\n\n\n\n\n";
const filepath = "/blog/ankr-announcement.md";
const tokens = tokenizer.tokenize(source);
const ast = Markdoc.parse(tokens);

/**
 * Like the AST, frontmatter won't change at runtime, so it is loaded at file root.
 * This unblocks future features, such a per-page dataFetchingFunction.
 */
const frontmatter = ast.attributes.frontmatter
  ? yaml.load(ast.attributes.frontmatter)
  : {};

const {components, ...rest} = getSchema(schema)

export async function getStaticProps(context) {
  const partials = {};

  // Ensure Node.transformChildren is available
  Object.keys(partials).forEach((key) => {
    const tokens = tokenizer.tokenize(partials[key]);
    partials[key] = Markdoc.parse(tokens);
  });

  const cfg = {
    ...rest,
    variables: {
      ...(rest ? rest.variables : {}),
      // user can't override this namespace
      markdoc: {frontmatter},
      // Allows users to eject from Markdoc rendering and pass in dynamic variables via getServerSideProps
      ...(context.variables || {})
    },
    partials,
    source,
  };

  /**
   * transform must be called in dataFetchingFunction to support server-side rendering while
   * accessing variables on the server
   */
  const content = await Markdoc.transform(ast, cfg);

  return {
    // Removes undefined
    props: JSON.parse(
      JSON.stringify({
        markdoc: {
          content,
          frontmatter,
          file: {
            path: filepath
          }
        },
      })
    ),
  };
}

export default function MarkdocComponent(props) {
  // Only execute HMR code in development
  return renderers.react(props.markdoc.content, React, {
    components: {
      ...components,
      // Allows users to override default components at runtime, via their _app
      ...props.components,
    },
  });
}
